import { render, staticRenderFns } from "./GetCustomerContacts.vue?vue&type=template&id=724f6ceb&scoped=true&"
import script from "./GetCustomerContacts.vue?vue&type=script&lang=js&"
export * from "./GetCustomerContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f6ceb",
  null
  
)

export default component.exports